import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompaniesService } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-companies-subdomain-dialog',
  templateUrl: './companies-subdomain-dialog.component.html',
  styleUrls: ['./companies-subdomain-dialog.component.scss'],
})
export class CompaniesSubdomainDialogComponent {
  company_id?: string;
  company_subdomain_form_group = this.form_service.company_subdomain_form_group;
  is_company_edit_running = false;

  constructor(
    private form_service: FormService,
    private dialog_ref: MatDialogRef<CompaniesSubdomainDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private companies_service: CompaniesService,
    private error_service: ErrorService,
  ) {
    this.company_id = data.company_id;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.isFormValid() && !this.is_company_edit_running && this.company_id) {
      const subdomain = this.company_subdomain_form_group.get(this.form_service.subdomain_label)?.value;
      this.setCustomSubdomain(this.company_id, subdomain);
    }
  }

  setCustomSubdomain(company_id: string, custom_subdomain: string): void {
    this.is_company_edit_running = true;
    this.companies_service.setCustomSubdomain(company_id, custom_subdomain).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_company_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_company_edit_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.company_subdomain_form_group);
  }
}
